var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "9px",
    viewBox: "0 0 15 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header",
    transform: "translate(-1010.000000, -21.000000)",
    fill: "#4D4D4D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User",
    transform: "translate(856.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Chevron/Primary",
    transform: "translate(154.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "7.5 11.8684379 0 3.53537132 0.595390525 3 7.5 10.6712548 14.4046095 3 15 3.53537132"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronSelect);
export default __webpack_public_path__ + "static/media/chevron_select.9d8a95aaa1cb990057fbf052cfe54c5c.svg";
export { ForwardRef as ReactComponent };